import defineComponent from 'flight';
import ItemsInViewportStorage from 'static/script/app/models/items-in-viewport-storage';
import viewport from 'static/script/utils/viewport';

function ItemsInViewportUI() {
    this._storage = new ItemsInViewportStorage();

    this.defaultAttrs({
        itemCardBody: '[data-item-card-body]',
        itemCardsSentAttribute: 'data-registered-in-viewport',
        itemCardsNotSent: '[data-item-card-body]:not([data-registered-in-viewport])',
        itemLink: '[data-item-link]',
        statusItemNotSent: 'NOT_SENT',
        statusItemSent: 'SENT'
    });

    this._logShowItems = function () {
        let itemCards = this.select('itemCardsNotSent');
        let $window = $(window);

        let vpTop = $window.scrollTop();
        let vpBottom = (window.innerHeight ? window.innerHeight : $window.height()) + $window.scrollTop();

        let itemId;
        let itemSearchId;

        let i = 0;
        // console.log('Iterate nr of cards: ' + itemCards.length);
        _.every(itemCards, function (item) {
            i++;
            // console.log('checkitem');
            let $item = $(item);

            itemId = $item.parent().attr('data-item-id');
            itemSearchId = $item.attr('data-search-id');

            if (itemId && !this._isAdded(itemId, itemSearchId) && viewport.isIn($item, vpBottom, vpTop)) {
                // console.log('Adding: ' + itemId);
                if (this.itemsShown.hasOwnProperty(itemSearchId)) {
                    $item.attr(this.attr.itemCardsSentAttribute, '');
                    this.itemsShown[itemSearchId][this.attr.statusItemNotSent].push(itemId);
                }
            } else if (viewport.isBelow($item, vpBottom)) {
                return false;
            }
            return true;
        }.bind(this));
    };

    this._allItems = function (itemSearchId) {
        if (this.itemsShown.hasOwnProperty(itemSearchId)) {
            return this.itemsShown[itemSearchId][this.attr.statusItemSent].concat(this.itemsShown[itemSearchId][this.attr.statusItemNotSent]);
        }

        return [];
    };

    this._isAdded = function (itemId, itemSearchId) {
        return _.contains(this._allItems(itemSearchId), itemId);
    };

    this._sendShownItems = function () {
        // var notSent = this.itemsShown[this.attr.statusItemNotSent];
        let searchId;
        let sendUs = [];

        for (searchId in this.itemsShown) {
            if (this.itemsShown.hasOwnProperty(searchId) && this.itemsShown[searchId][this.attr.statusItemNotSent].length > 0) {
                sendUs.push({
                    searchId: searchId,
                    items: this.itemsShown[searchId][this.attr.statusItemNotSent]
                });

                this.itemsShown[searchId][this.attr.statusItemSent] = this._allItems(searchId);
                this.itemsShown[searchId][this.attr.statusItemNotSent] = [];
            }
        }

        if (sendUs.length > 0) {
            this.trigger('ui:items-in-viewport:on-send-items', {sendUs: sendUs});
            this._storage.saveAllItems(sendUs);
        }
    };

    this._init = function () {
        this.itemsShown = {};

        this._currentSearchIds = _.chain(this.select('itemCardBody'))
            .map(function (element) {
                return $(element).attr('data-search-id');
            }).uniq()
            .value();

        let storedItems = this._storage.getItemsBySearchIds(this._currentSearchIds),
            storedItem;

        _.each(this._currentSearchIds, function (searchId) {

            storedItem = _.find(storedItems, function(item) {
                return (item.searchId === searchId);
            }) || [];

            this.itemsShown[searchId] = {};
            this.itemsShown[searchId][this.attr.statusItemNotSent] = [];
            this.itemsShown[searchId][this.attr.statusItemSent] = storedItem.items || [];
        }.bind(this));

        // Add a timeout because if we're using pjax, this will trigger before window gets scrolled to top
        // and wrong items will be registered on some pages
        this.timeout = setTimeout(function () {
            this._logShowItems();
            this._sendShownItems();
        }.bind(this), 200);
    };

    this.after('initialize', function () {
        // console.log('initialize');

        this._init();

        let throttledOnScroll = _.throttle(this._logShowItems, 900);
        this.on(document, 'scroll', throttledOnScroll);

        let debouncedItemsToSend = _.debounce(this._sendShownItems, 1000);

        this.on(document, 'ui:search-result:after-pagination', this._init);
        this.on(document, 'utils:window-scroll:on-stop', debouncedItemsToSend);
        this.on(document, 'data:navigation:before-page-load', debouncedItemsToSend);
    });
}

export default defineComponent.component(ItemsInViewportUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/items-in-viewport-ui.js